import { AnyAction } from 'redux';
import {
  AccountInfoState,
  DepartmentList,
  FeatureFlags,
  UserList,
  SendersList,
  SmsTemplateList,
} from '~/types/accountInfo';
import * as actionTypes from '~/store/actions/actionTypes';

export interface SetDepartmentsAction {
  type: typeof actionTypes.ACCOUNT_INFO_SET_DEPARTMENTS;
  payload: DepartmentList;
}

export interface SetUsersAction {
  type: typeof actionTypes.ACCOUNT_INFO_SET_USER_LIST;
  payload: UserList;
}

export interface SetSendersAction {
  type: typeof actionTypes.ACCOUNT_INFO_SET_SENDERS;
  payload: SendersList;
}

export interface SetSmsTemplatesAction {
  type: typeof actionTypes.ACCOUNT_INFO_SET_SMS_TEMPLATE;
  payload: SmsTemplateList;
}

export interface SetFeatureFlagsAction {
  type: typeof actionTypes.ACCOUNT_INFO_SET_FEATURE_FLAGS;
  payload: FeatureFlags;
}

export interface SetTourCompletedAction {
  type: typeof actionTypes.ACCOUNT_INFO_SET_TOUR_COMPLETED;
  payload: boolean;
}

type AccountInfoActions =
  | SetUsersAction
  | SetDepartmentsAction
  | SetSendersAction
  | SetSmsTemplatesAction
  | SetFeatureFlagsAction
  | SetTourCompletedAction;

export const initialState: AccountInfoState = {
  users: [],
  departments: [],
  smsTemplates: [],
  smsSenders: [],
  featureFlags: {
    isWhatsappEnabled: false,
  },
  tourCompleted: false,
  // TODO: Once whatsapp is added, bring the integrations here... accountIntegrations -> activeIntegrations: [],
};

const reducer = (
  state: AccountInfoState = initialState,
  action: AccountInfoActions | AnyAction // To handle other actions as the project is not fully typed yet
): AccountInfoState => {
  switch (action.type) {
    case actionTypes.ACCOUNT_INFO_SET_USER_LIST:
      return {
        ...state,
        users: action.payload,
      };
    case actionTypes.ACCOUNT_INFO_SET_DEPARTMENTS:
      return {
        ...state,
        departments: action.payload,
      };
    case actionTypes.ACCOUNT_INFO_SET_SMS_TEMPLATE:
      return {
        ...state,
        smsTemplates: action.payload,
      };
    case actionTypes.ACCOUNT_INFO_SET_TOUR_COMPLETED:
      return {
        ...state,
        tourCompleted: action.payload,
      };
    case actionTypes.ACCOUNT_INFO_SET_SENDERS:
      return {
        ...state,
        smsSenders: action.payload,
      };
    case actionTypes.ACCOUNT_INFO_SET_FEATURE_FLAGS:
      return {
        ...state,
        featureFlags: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
